import strapiClient from './config';

export const getContent = async (dataUrl, isCollection, isWorkshop, isFreebie=false) => {
    let result;
    if (isCollection) {
        if (isWorkshop) {
            let url = '/api/workshop/' + dataUrl.slug;
            result = await strapiClient.get(url);
            return result;
        } else if (isFreebie) {
            let url = '/api/freebie/public/' + dataUrl.slug;
            result = await strapiClient.get(url);
            return result;
        } else {
            let url = '/api/' + dataUrl.collections + '?filters[Slug][$eq]=' + dataUrl.slug + '&';
            dataUrl.components.forEach((component) => {
                url = url + 'populate' + component;
            });
            result = await strapiClient.get(url);
            return result;
        }
    } else {
        let url = '/api/' + dataUrl.page + '?';
        dataUrl.components.forEach((component) => {
            url = url + 'populate' + component;
        });
        result = await strapiClient.get(url);
        return result;
    }
};

export const postContent = async (apiUrl, data) => {
    let url = '/api/' + apiUrl;
    let result = await strapiClient.post(url, data);
    return result;
}